import React, { StrictMode } from 'react';
import { ContextProvider as UsersContextProvider } from 'components/Users/Context';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from 'app/routes';
import Main from './Main';

import UpdatePassword from './UpdatePassword';
import UpdateEmail from './UpdateEmail';

export default function Index() {
  const router = createBrowserRouter([
    {
      path: routes.members.settings.index,
      element: <Main />,
      children: [
        {
          path: routes.members.settings.passwordUpdate,
          element: <UpdatePassword />,
        },
        {
          path: routes.members.settings.emailUpdate,
          element: <UpdateEmail />,
        },
      ],
    },
  ]);

  return (
    <StrictMode>
      <UsersContextProvider>
        <RouterProvider router={router} />
      </UsersContextProvider>
    </StrictMode>
  );
}
